import http from '../HttpWrapper'
import { PersonDto } from '../person/models/PersonDto'
import type { PersonNetworkImportStatusSummaryDto } from '../person/PersonApi'

export type MagicLinkResponse = { ok: boolean }
export type LoginResponse = { ok: boolean }
export type LogoutResponse = { ok: boolean }
export type MagicLoginResponse = { ok: boolean }
export type AuthMeResponse = { user: { id: string; email: string } | null }
export type AuthMeDetailedResponse = {
    user: {
        id: string
        email: string
        name?: string
        referralCode?: string
    } | null
    person: PersonDto | null
    personNetworkImportStatus?: PersonNetworkImportStatusSummaryDto | null
}
export type SignupResponse = { ok: boolean }
export type CheckEmailResponse = { exists: boolean }

class AuthApi {
    private static instance: AuthApi

    public constructor() {
        if (AuthApi.instance) {
            return AuthApi.instance
        }

        AuthApi.instance = this
    }

    public async requestMagicLink(
        email: string,
        recaptchaToken?: string,
        target?: string,
    ): Promise<MagicLinkResponse> {
        return await http.post(
            '/auth/magic-link',
            { email, recaptchaToken, target },
            undefined,
            undefined,
            false,
        )
    }

    public async magicLogin(token: string): Promise<MagicLoginResponse> {
        return await http.post(
            '/auth/magic-login',
            { token },
            undefined,
            undefined,
            false,
        )
    }

    public async signupMagicLink(
        email: string,
        name?: string,
        recaptchaToken?: string,
    ): Promise<MagicLinkResponse> {
        return await http.post(
            '/auth/signup-magic-link',
            { email, name, recaptchaToken },
            undefined,
            undefined,
            false,
        )
    }

    public async signupWithPassword(
        email: string,
        password: string,
        name?: string,
        recaptchaToken?: string,
    ): Promise<SignupResponse> {
        return await http.post(
            '/auth/signup',
            { email, password, name, recaptchaToken },
            undefined,
            undefined,
            false,
        )
    }

    public async loginWithPassword(
        email: string,
        password: string,
        recaptchaToken?: string,
    ): Promise<LoginResponse> {
        return await http.post(
            '/auth/login',
            { email, password, recaptchaToken },
            undefined,
            undefined,
            false,
        )
    }

    public async logout(): Promise<LogoutResponse> {
        return await http.post(
            '/auth/logout',
            undefined,
            undefined,
            undefined,
            false,
        )
    }

    public async getMe(): Promise<AuthMeResponse> {
        return await http.get('/auth/me', undefined, undefined, false)
    }

    public async getMeDetails(): Promise<AuthMeDetailedResponse> {
        return await http.get('/auth/me/details', undefined, undefined, false)
    }

    public async checkEmailExists(
        email: string,
        recaptchaToken?: string,
    ): Promise<CheckEmailResponse> {
        return await http.post(
            '/auth/check-email',
            { email, recaptchaToken },
            undefined,
            undefined,
            false,
        )
    }
}

const authApi = new AuthApi()
export default authApi
